const axios = require('axios');

/**
 *classification get api
 * to get the list of classifications */
export async function getData(url) {
  let list = '';
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}${url}`)
    .then((response) => { list = response.data; })
    .catch((err) => {
      console.log('classification java api error', err); // eslint-disable-line no-console
    });
  return list;
}

/**
 * classification get api
 * to get the list of classifications based on search */
export async function callSearch(productId) {
  let list = '';
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/resources/standards?product_class_id=${productId}`)
    .then((response) => {
      list = response.data;
    })
    .catch((err) => {
      console.log('classification search java api error', err); // eslint-disable-line no-console
    });
  return list;
}
/**
 * classification get api
 * to get the list of classifications based on search */
export async function searchProductCategories(productCategoryId) {
  let list = '';
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/resources/product_category_standards?product_category_id=${productCategoryId}`)
    .then((response) => {
      list = response.data;
    })
    .catch((err) => {
      console.log('classification search java api error', err); // eslint-disable-line no-console
    });
  return list;
}
